import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/about-us/AnimatedCounter.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/csr/ReadMoreButton.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Chip"] */ "/app/node_modules/@heroui/chip/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
